import * as React from 'react';
import { useTheme } from '../../theme';
import Slider, { Settings } from 'react-slick';
import { CdnIcon } from '@shared/ui';
import cn from 'classnames';

const SlickSlider = React.forwardRef<Slider, React.PropsWithChildren<Settings>>(
	({ children, className, ...props }, ref) => {
		const theme = useTheme('SlickSlider').SlickSlider;

		return (
			<Slider
				ref={ref}
				className={cn(theme.slider, className)}
				prevArrow={
					<button type="button">
						<CdnIcon icon="Arrow/Chevron_left" />
					</button>
				}
				nextArrow={
					<button type="button">
						<CdnIcon icon="Arrow/Chevron_right" />
					</button>
				}
				{...props}
			>
				{children}
			</Slider>
		);
	}
);

export default SlickSlider;
